import { Trash } from "lucide-react"
import BaseTableRow from "../../../components/layout/BaseTableRow"
import { KeycollectionType } from "../../Objekte/types/types"

type KeyTableRowType = {
    keyItem: KeycollectionType
    openKeyModal: () => void
    deleteKey: (e: any) => void
}

export default function KeyTableRow(props: KeyTableRowType) {
    return (
        <BaseTableRow onClick={props.openKeyModal}>
            <td className="table-cell">
                <p className="line-clamp-1 text-center min-w-[4rem]">
                    {props.keyItem?.name}
                </p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center min-w-[4rem]">
                    {props.keyItem?.keyCount}
                </p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center min-w-[4rem]">
                    {props.keyItem?.keys}
                </p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center min-w-[6rem]">
                    {props.keyItem?.signature ? "Unterschrieben" : "Nicht unterschrieben"}
                </p>
            </td>
            <td className="table-cell"> 
                <Trash className="w-4 h-4 cursor-pointer" onClick={props.deleteKey} />
            </td>
        </BaseTableRow>
    )
}
